import React from 'react'
import { SelectInline, InputInline, Field } from '@arnsbogroup/react-voicearchive'


const AgencyInfo = ( {agency, onChange = () => {}} ) => {
  const currencyOptions = [
    { label: 'USD', value: 1 },
    { label: 'EUR', value: 2 },
    { label: 'DKK', value: 3 },
    { label: 'GBP', value: 4 },
    { label: 'NOK', value: 5 },
    { label: 'SEK', value: 6 },
    { label: 'ZAR', value: 58 },
  ]

  if (!agency) {
    return null
  }

  return (
    <div className="p-4 text-center">
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 flex-initial w-full text-left order-3 md:order-none">
        <div className="space-y-4">
          <div>
            <Field label="Agency Username" labelClassName="text-xs">
              { agency.username }
            </Field>
          </div>
          <div>
            <InputInline
              labelClassName="text-xs"
              placeholder="Agency Name"
              label="Agency Name"
              value={ agency.name }
              onChange={({ target: { value } }) => {
                onChange({ ...agency, name: value })
              }}
            />
          </div>
          <div>
            <SelectInline
              labelClassName="text-xs"
              label="Agency Currency"
              placeholder="Currency"
              value={ currencyOptions.find(currency => agency.agencySupplier.currencyObject.uid == currency.value) }
              options={ currencyOptions }
              onChange={(currency) => { onChange({
                ...agency, 
                agencySupplier: {
                    ...agency.agencySupplier,
                    currencyObject: {
                      ...agency.agencySupplier.currencyObject,
                      uid: currency.value
                    }
                }
            }) }}
            />
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <Field label="User id" labelClassName="text-xs">
              { agency.agencySupplier.userid }
            </Field>
          </div>
          <div>
            <Field label="User name" labelClassName="text-xs">
              { agency.agencySupplier.firstname.concat(" ", agency.agencySupplier.lastname) }
            </Field>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgencyInfo
